export class Achivement {
    ID:number;
CLIENT_ID:number;
TITLE:string;
DESCRIPTION:string;
ICON:string;
SEQUENCE_NO:number;
STATUS:boolean=true;

}